import { post } from "./ApiService";


const ZohoService = {
  async createAccount(accountName, website = '', phone = '') {
    try {
      const res = await post('zoho/account', {
        accountName,
        website,
        phone
      });
      return res?.data?.data?.[0]?.details?.id || null;
    } catch (error) {
      console.error('Failed to create Zoho account:', error);
      return null;
    }
  },

  async createDeal(dealName, stage, amount, accountId) {
    try {
      return await post('zoho/deal', {
        dealName,
        stage,
        amount,
        accountId
      });
    } catch (error) {
      console.error('Failed to create Zoho deal:', error);
      return null;
    }
  },

  async createLead({ email, firstName, lastName, company, leadSource, phone }) {
    try {
      return await post('zoho/lead', {
        email,
        firstName,
        lastName,
        company,
        leadSource,
        phone
      });
    } catch (error) {
      console.error('Failed to create Zoho lead:', error);
      return null;
    }
  }
};

export default ZohoService;